import { useMemo, useState } from 'react'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  fetchSavedFilters,
  saveFilter,
  updateFilter,
} from 'features/dashboard/filter/dashboardFilterSlice'
import { failWithErrorResponse, success } from 'features/toast/Toast'
import RadioButton from 'components/form/RadioButton'
import TextInput from 'components/form/TextInput'
import SelectBox from 'components/form/SelectBox'

const FilterSaveTypes = {
  UPDATE: 'UPDATE',
  CREATE: 'CREATE',
}
const FilterManageModal = ({ handleClose, savedFilters }) => {
  const dispatch = useDispatch()
  const { isLoading } = useSelector(
    state => state.dashboard.filter,
    shallowEqual
  )
  const [type, setType] = useState(
    savedFilters.length > 0 ? FilterSaveTypes.UPDATE : FilterSaveTypes.CREATE
  )
  const [selectedId, setSelectedId] = useState()
  const [name, setName] = useState('')
  const hasNameError = useMemo(
    () =>
      type === FilterSaveTypes.CREATE &&
      savedFilters.findIndex(item => item.name === name.trim()) !== -1,
    [type, name, savedFilters]
  )
  const hasLengthError = useMemo(
    () => type === FilterSaveTypes.CREATE && savedFilters.length >= 20,
    [type, savedFilters]
  )
  const disabled = useMemo(
    () =>
      isLoading ||
      (type === FilterSaveTypes.CREATE && name.trim().length === 0) ||
      (type === FilterSaveTypes.UPDATE && selectedId === undefined),
    [isLoading, type, name, selectedId]
  )

  const handleConfirm = async ({ preventClose }) => {
    const fetcher =
      type === FilterSaveTypes.CREATE
        ? saveFilter(name)
        : updateFilter(selectedId)
    const { error, payload } = await dispatch(fetcher)
    if (error) {
      preventClose()
      failWithErrorResponse(payload)
    } else {
      dispatch(fetchSavedFilters())
      success('변경사항이 적용되었습니다')
    }
  }

  return (
    <ConfirmModal
      title="검색 조건 저장"
      handleClose={handleClose}
      confirmDisabled={disabled || hasNameError || hasLengthError}
      onConfirm={handleConfirm}>
      <ul className="list_savesearch">
        <li>
          <RadioButton
            label="기존 검색 조건에 업데이트하기"
            disabled={savedFilters.length === 0}
            checked={type === FilterSaveTypes.UPDATE}
            onClick={() => {
              setName('')
              setType(FilterSaveTypes.UPDATE)
            }}
          />
          {type === FilterSaveTypes.UPDATE && (
            <SelectBox
              placeholder="저장한 검색 조건 중에서 선택"
              noBlurOnDefault
              value={selectedId}
              onValueChange={v => setSelectedId(v)}>
              {savedFilters.map(item => (
                <SelectBox.Item key={item.id} value={item.id}>
                  {item.name}
                </SelectBox.Item>
              ))}
            </SelectBox>
          )}
        </li>
        <li>
          <RadioButton
            label="새로 저장하기"
            checked={type === FilterSaveTypes.CREATE}
            onClick={() => {
              setSelectedId(undefined)
              setType(FilterSaveTypes.CREATE)
            }}
          />
          {type === FilterSaveTypes.CREATE && (
            <>
              <p className="txt_copy">
                입력하는 이름으로 바로 대시보드 검색창에서 이 필터 조건을 불러올
                수 있습니다.
              </p>
              <TextInput
                placeholder="저장할 검색 필터 이름을 입력하세요."
                maxLength={20}
                error={hasNameError || hasLengthError}
                value={name}
                onValueChange={v => setName(v)}
              />
              {hasLengthError && (
                <p className="txt_error">
                  저장한 검색 조건의 최대 저장개수를 초과했습니다. 기존 검색
                  조건에 업데이트하거나 삭제 후 다시 시도하세요.
                </p>
              )}
              {hasNameError && !hasLengthError && (
                <p className="txt_error">
                  동일한 이름으로 저장한 검색 조건이 있습니다. 다른 이름으로
                  설정하세요.
                </p>
              )}
            </>
          )}
        </li>
      </ul>
    </ConfirmModal>
  )
}
FilterManageModal.propTypes = {
  handleClose: PropTypes.func,
  savedFilters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
}
export default FilterManageModal
